import { render } from "./AsignarDespachoModal.vue?vue&type=template&id=12fb751a&scoped=true"
import script from "./AsignarDespachoModal.vue?vue&type=script&lang=js"
export * from "./AsignarDespachoModal.vue?vue&type=script&lang=js"

import "./AsignarDespachoModal.vue?vue&type=style&index=0&id=12fb751a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-12fb751a"]])

export default __exports__